import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AuthState {
  isAuthenticated: boolean;
  token?: string;
}

const initialState: AuthState = {
  isAuthenticated: false,
  token: undefined,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setIsAuthenticated: (state, action: PayloadAction<boolean>) => {
      return { ...state, isAuthenticated: action.payload };
    },
    setToken: (state, action: PayloadAction<string>) => {
      return { ...state, token: action.payload };
    },
    logout: (state) => {
      return { ...state, isAuthenticated: false, token: undefined };
    },
  },
});

export const { setIsAuthenticated, setToken, logout } = authSlice.actions;
export default authSlice.reducer; 